<dhp-article-purchase-account-shell
  [eyebrowKey]="'pages.articlePurchase.emailContinuation.eyebrow'"
  [titleKey]="'pages.articlePurchase.emailContinuation.title'"
  [descriptionKey]="'pages.articlePurchase.emailContinuation.description'"
  [noticeKey]="null"
  [showSummary]="false"
>
  @if (email(); as email) {
    <div>
      <p
        class="mb-4 text-primary-text"
        [innerHTML]="
          'pages.articlePurchase.emailContinuation.descriptionWithEmail'
            | translate: { email }
        "
      ></p>
      <p class="text-primary-text">
        {{ 'pages.articlePurchase.emailContinuation.helpText' | translate }}
      </p>
    </div>
  }

  <div class="flex flex-col gap-3 sm:flex-row sm:items-center">
    @if (articleId(); as articleId) {
      <a
        class="btn-primary btn sm:w-fit"
        [routerLink]="['/articles', articleId]"
      >
        {{
          'pages.articlePurchase.emailContinuation.backToArticle' | translate
        }}
      </a>
    }

    <a class="btn-secondary btn sm:w-fit" [routerLink]="['/']">
      {{ 'pages.articlePurchase.success.backHome' | translate }}
    </a>
  </div>
</dhp-article-purchase-account-shell>
